import React from 'react';
import Modal from 'react-modal';
import { Button } from './Button';
import { ReactComponent as CloseIcon } from '../assets/icons/x.svg';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'default';
  isLoading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'default',
  isLoading = false,
}) => {
  return (
    <Modal
      className="modal-content md:max-w-[400px]"
      overlayClassName="modal-overlay"
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={title}
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-primary font-medium text-xl">{title}</h2>
        <Button onClick={onClose} variant="icon" disabled={isLoading}>
          <CloseIcon className="w-3 h-3" />
        </Button>
      </div>

      {/* Message */}
      <p className="text-gray-600 mb-6">{message}</p>

      {/* Actions */}
      <div className="flex justify-end gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          disabled={isLoading}
        >
          {cancelText}
        </Button>
        <Button
          type="button"
          variant={variant === 'danger' ? 'danger' : 'primary'}
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
};
